export default "__VITE_ASSET__57244e82__"